<template>
  <div v-if="marketingCookie" ref="container" class="klarna-promo">
    <klarna-placement
      v-if="visible"
      class="klarna-calculator"
      :data-key="type"
      data-locale="de-DE"
      :data-purchase-amount="(pdsShoppingCartPrice * 100).toFixed(0)"
    />
  </div>
</template>

<script setup lang="ts">
import type { Price, PromotionPrice } from "@expert/types";
import { getCookiePermissions, PermissionMapping } from "~/composables/states";
import { useElementVisibility } from "@vueuse/core";

interface Props {
  price: Price;
  promotionPrice?: PromotionPrice;
  type: string;
}

const props = defineProps<Props>();

const marketingCookie: Ref<boolean> = getCookiePermissions(PermissionMapping.MARKETING);
const container = ref<HTMLElement | null>(null);

const isContainerVisible = useElementVisibility(container, {
  rootMargin: "200px",
});

const visible = ref(false);

const pdsShoppingCartPrice = computed(() => {
  const activeBundlePrice = usePDSActiveBundlePrice().value;
  const basePrice = props.promotionPrice?.checkoutPrice ?? props.price?.bruttoPrice;

  if (activeBundlePrice && activeBundlePrice > 0) {
    return basePrice + activeBundlePrice;
  }

  return basePrice;
});

const stop = watch(isContainerVisible, async (isVisible) => {
  if (!isVisible || visible.value) return;

  visible.value = true;
  await nextTick();
  window.Klarna?.OnsiteMessaging?.refresh();
  stop();
}, { immediate: true });
</script>

<style scoped>
.klarna-calculator::part(osm-container) {
  border: none;
}
</style>